// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1mg-z","imageUploader":"EGiftCard_imageUploader__36ctc"};